import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import {
  HeyLightConfigDTO,
  StripeConfigDTO,
} from "../../NormasTeachingCheckout/PaymentMethodConfiguration.ts";
import { NormasTeachingBundleDTO } from "./useNormasTeachingBundleById.ts";

export function useCreateNormasTeachingBundle() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);
  const createNormasTeachingBundle = async (input: {
    bundleName: string;
    variantBundleName: string;
    priceInCents: {
      amount: number;
      currency: "EUR";
    };
    purchaseAcTags: string[];
    refundAcTags: string[];
    bundleProducts: {
      products: {
        id: string;
        priceInCents: {
          amount: number;
          currency: "EUR";
        };
      }[];
    }[];
    analyticsTag?: string;
    stripeConfig?: StripeConfigDTO;
    heylightConfig?: HeyLightConfigDTO;
    bundleDescription?: string;
    isCouponEnabled?: boolean;
  }): Promise<NormasTeachingBundleDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingBundleDTO>(
          `/bundles`,
          input,
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    createNormasTeachingBundle,
    loading,
  };
}
